import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CustomTreeChecklistComponent } from './custom-tree-checklist/custom-tree-checklist.component';
import { RespondentEditComponent } from './respondent-edit/respondent-edit.component';
import { RespondentsModalComponent } from './respondents-modal/respondents-modal.component';
import { UnitsNotificationDialogComponent } from './units-notification-dialog/units-notification-dialog.component';
import { CreditBalanceDialogComponent } from './credit-balance-dialog/credit-balance-dialog.component';
import { ErrorComponent } from './error/error.component';
import { DrillDownDialogComponent } from './drill-down-dialog/drill-down-dialog.component';
import { LpHeaderComponent } from './lp-header/lp-header.component';

import { ResponseDialogComponent } from './response-dialog/response-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { TranslationInputComponent } from './translation-input/translation-input.component';
import { MasterSnackBarComponent } from './master-snack-bar/master-snack-bar.component';
import { ChartComponent } from './chart/chart.component';
import { SettingsComponent } from '../common/settings/settings.component';

import { ReportFooterComponent } from './export-components/report-footer/report-footer.component';
import { ReportHeaderComponent } from './export-components/report-header/report-header.component';

import { RespondentsPoolComponent } from './respondents-pool/respondents-pool.component';
import { CriteriaComponent } from './criteria/criteria.component';
import { QHeaderComponent } from './questionnaire/q-header/q-header.component';
import { StartPageComponent } from './questionnaire/start-page/start-page.component';
import { MainPageComponent } from './questionnaire/main-page/main-page.component';
import { MultiOptionsMultiAnswerComponent } from './questionnaire/questions/multi-options-multi-answer/multi-options-multi-answer.component';
import { ProgressComponent } from './questionnaire/progress/progress.component';
import { SubQuestionsBinaryLikenessRatingComponent } from './questionnaire/questions/sub-questions-binary-likeness-rating/sub-questions-binary-likeness-rating.component';
import { TextComponent } from './questionnaire/questions/text/text.component';
import { RatingLikedComponent } from './questionnaire/questions/rating-liked/rating-liked.component';
import { SubQuestionsRatingComponent } from './questionnaire/questions/sub-questions-rating/sub-questions-rating.component';
import { EndPageComponent } from './questionnaire/end-page/end-page.component';
import { QMetricsComponent } from './questionnaire/q-metrics/q-metrics.component';
import { SingleAnswerConfidenceComponent } from './questionnaire/questions/single-answer-confidence/single-answer-confidence.component';
import { SingleAnswerOutTenComponent } from './questionnaire/questions/single-answer-out-ten/single-answer-out-ten.component';
import { StarRatingComponent } from './questionnaire/questions/star-rating/star-rating.component';
import { RightPreviewComponent } from './export-components/right-preview/right-preview.component';
import { ConstantSumCvfComponent } from './questionnaire/questions/constant-sum-cvf/constant-sum-cvf.component';

import { HeatmapComponent } from './heatmap/heatmap.component';
import { ReportPageComponent } from './export-components/report-page/report-page.component';
import { LeftPreviewComponent } from './export-components/left-preview/left-preview.component';
import { ZenSliderComponent } from './questionnaire/questions/zen-slider/zen-slider.component';
import { QFooterComponent } from './questionnaire/q-footer/q-footer.component';
import "@lottiefiles/lottie-player";


import { PeopleComponent } from './people/people.component';
import { SingleAnswerConfidenceWithNaComponent } from './questionnaire/questions/single-answer-confidence-with-na/single-answer-confidence-with-na.component';
import { SectionLoaderComponent } from './section-loader/section-loader.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { TicketDialogComponent } from './help-center/ticket-dialog/ticket-dialog.component';
import { StatusButtonComponent } from './status-button/status-button.component';
import { NativeExportBaseComponent } from './native-export-base/native-export-base.component';
import { PaginatorComponent } from './temp-table/paginator/paginator.component';
import { SingleAnswerTenComponent } from './data-display/single-answer-ten/single-answer-ten.component';
import { ExportChartVerticalComponent } from './export-components/export-chart-vertical/export-chart-vertical.component';
import { AnalysisQuestionComponent } from './components/analysis-question/analysis-question.component';
import { ExportQuestionComponent } from './components/export-question/export-question.component';
import { JsonToExcelComponent } from './export-components/json-to-excel/json-to-excel.component';
import { QrCodeModule } from 'ng-qrcode';
import { ChartWrapperComponent } from './chart/chart-wrapper/chart-wrapper.component';
import { LiveSurveyTimeChangesComponent } from './components/live-survey-time-changes/live-survey-time-changes.component';
import { FilterTopicsPipe } from './comments-ai/filter-topics.pipe';
import { SurveyCriteriaComponent } from './components/survey-criteria/survey-criteria.component';

import { DemoReportPageComponent } from './demo-account/demo-report-page/demo-report-page.component';
import { ProductTourModule } from './product-tour/product-tour.module';
import { PdfChartExporterComponent } from './chart-exporter/pdf-chart-exporter/pdf-chart-exporter.component';
import { EnpsChartComponent } from './enps-chart/enps-chart.component';
import { SharedLandingComponent } from './questionnaire/shared-landing/shared-landing.component';
import { ConfidenceComponent } from './questionnaire/questions/confidence/confidence.component';
import { GenerationInfoComponent } from './components/generation-info/generation-info.component';
import { ZenChartModule } from '../core/modules/chart/chart.module';

import { ThemeModule } from './Theme/theme.module';
import { GlobalFiltersModule } from '../core/modules/global-filters/global-filters.module';
import { ComponentPortal } from '@angular/cdk/portal';
import { ZenSnackbarComponent } from './Theme/components/zen-snackbar/zen-snackbar.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ZenSnackbarService } from './Theme/services/zen-snackbar.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { ProductBenchmarkComponent } from './components/product-benchmark/product-benchmark.component';
import { BenchmarkTemplateComponent } from './ui/benchmark-template/benchmark-template.component';
import { EnpsDefaultComponent } from './enps-default/enps-default.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ChartModule } from './chart-new/chart.module';
import { CompanyTreeComponent } from '../common/settings/company-tree/company-tree.component';
import { ExportEChartVerticalComponent } from './export-components/export-e-chart-vertical/export-e-chart-vertical.component';
import {
  NotificationSettingsComponent,
  PerformanceRateSettingsComponent,
  BandLevelSettingsComponent,
  JobGradeSettingsComponent,
  CompaniesSettingsComponent,
  UsersSettingsComponent,
  CompanyStructureSettingsComponent,
  ExtraCriteriaSettingsComponent,
  IntegrationSettingsComponent,
} from '../common/settings/components';

import { ThomasEditorComponent } from './thomas-editor/thomas-editor.component';
import { ThomasTempTableComponent } from './thomas-temp-table/thomas-temp-table.component';


@NgModule({
  declarations: [
    JsonToExcelComponent,
    CustomDropdownComponent,
    NavigationBarComponent,
    TranslationInputComponent,
    MasterSnackBarComponent,
    ChartComponent,
    DrillDownDialogComponent,
    LpHeaderComponent,
    ResponseDialogComponent,
    ConfirmationDialogComponent,
    ErrorComponent,
    CreditBalanceDialogComponent,
    UnitsNotificationDialogComponent,
    RespondentEditComponent,
    RespondentsModalComponent,
    CustomTreeChecklistComponent,
    SettingsComponent,
    ReportFooterComponent,
    ReportHeaderComponent,
    RespondentsPoolComponent,
    CriteriaComponent,
    QHeaderComponent,
    StartPageComponent,
    MainPageComponent,
    MultiOptionsMultiAnswerComponent,
    ConstantSumCvfComponent,
    ProgressComponent,
    SubQuestionsBinaryLikenessRatingComponent,
    TextComponent,
    RatingLikedComponent,
    SubQuestionsRatingComponent,
    EndPageComponent,
    QMetricsComponent,
    SingleAnswerConfidenceComponent,
    SingleAnswerOutTenComponent,
    StarRatingComponent,
    RightPreviewComponent,
    HeatmapComponent,
    ReportPageComponent,
    LeftPreviewComponent,
    ZenSliderComponent,
    QFooterComponent,
    PeopleComponent,
    SingleAnswerConfidenceWithNaComponent,
    SectionLoaderComponent,
    HelpCenterComponent,
    TicketDialogComponent,
    StatusButtonComponent,
    NativeExportBaseComponent,
    PaginatorComponent,
    SingleAnswerTenComponent,
    ExportChartVerticalComponent,
    AnalysisQuestionComponent,
    ExportQuestionComponent,
    ChartWrapperComponent,
    FilterTopicsPipe,
    LiveSurveyTimeChangesComponent,
    SurveyCriteriaComponent,
    DemoReportPageComponent,
    PdfChartExporterComponent,
    EnpsChartComponent,
    SharedLandingComponent,
    ConfidenceComponent,
    GenerationInfoComponent,
    ProductBenchmarkComponent,
    BenchmarkTemplateComponent,
    EnpsDefaultComponent,
    CompanyTreeComponent,
    ExportEChartVerticalComponent,
    ThomasEditorComponent,
    ThomasTempTableComponent
  ],
  exports: [
    CustomDropdownComponent,
    NavigationBarComponent,
    TranslationInputComponent,
    MasterSnackBarComponent,
    ChartComponent,
    DrillDownDialogComponent,
    LpHeaderComponent,
    ResponseDialogComponent,
    ConfirmationDialogComponent,
    ErrorComponent,
    CreditBalanceDialogComponent,
    UnitsNotificationDialogComponent,
    RespondentEditComponent,
    RespondentsModalComponent,
    CustomTreeChecklistComponent,
    SettingsComponent,
    ReportFooterComponent,
    ReportHeaderComponent,
    RespondentsPoolComponent,
    CriteriaComponent,
    QHeaderComponent,
    StartPageComponent,
    MainPageComponent,
    MultiOptionsMultiAnswerComponent,
    ConstantSumCvfComponent,
    ProgressComponent,
    SubQuestionsBinaryLikenessRatingComponent,
    TextComponent,
    RatingLikedComponent,
    SubQuestionsRatingComponent,
    EndPageComponent,
    QMetricsComponent,
    SingleAnswerConfidenceComponent,
    SingleAnswerOutTenComponent,
    StarRatingComponent,
    RightPreviewComponent,
    HeatmapComponent,
    ReportPageComponent,
    LeftPreviewComponent,
    ZenSliderComponent,
    QFooterComponent,
    PeopleComponent,
    SingleAnswerConfidenceWithNaComponent,
    SectionLoaderComponent,
    StatusButtonComponent,
    NativeExportBaseComponent,
    PaginatorComponent,
    SingleAnswerTenComponent,
    ExportChartVerticalComponent,
    AnalysisQuestionComponent,
    ExportQuestionComponent,
    JsonToExcelComponent,
    QrCodeModule,
    ChartWrapperComponent,
    FilterTopicsPipe,
    LiveSurveyTimeChangesComponent,
    SurveyCriteriaComponent,
    PdfChartExporterComponent,
    ZenChartModule,
    EnpsChartComponent,
    SharedLandingComponent,
    ConfidenceComponent,
    GenerationInfoComponent,
    ThemeModule,
    ProductTourModule,
    ProductBenchmarkComponent,
    BenchmarkTemplateComponent,
    EnpsDefaultComponent,
    ChartModule,
    CompanyTreeComponent,
    ExportEChartVerticalComponent,
    ThomasEditorComponent,
    ThomasTempTableComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    CommonModule,
    RouterModule,
    ThemeModule,
    QrCodeModule,
    ProductTourModule,
    ZenChartModule,
    ChartModule,
    GlobalFiltersModule,
    // Settings child components (standalone)
    NotificationSettingsComponent,
    PerformanceRateSettingsComponent,
    BandLevelSettingsComponent,
    JobGradeSettingsComponent,
    CompaniesSettingsComponent,
    UsersSettingsComponent,
    CompanyStructureSettingsComponent,
    ExtraCriteriaSettingsComponent,
    IntegrationSettingsComponent,
  ],
  providers: [

    TranslatePipe,
    ZenSnackbarService
  ]
})
export class SharedModule {
  private snackbarOverlay: OverlayRef = this.overlay.create({ panelClass: 'z-999998' });

  constructor(private overlay: Overlay, private snackbar: ZenSnackbarService) {
    snackbar.clearSnackBar();
    if (!this.snackbarOverlay.hasAttached())
      this.snackbarOverlay.attach(new ComponentPortal(ZenSnackbarComponent));
  }
}